import {createSlice} from '@reduxjs/toolkit';

const classesSlice = createSlice({
    name: 'classes',
    initialState: {
        items: [],
        nextPage: 0,
        hasMore: false,
        length: 0,
        search: "",
        day: "",
        dayid: 0,
    },
    reducers: {
        addItems(state, action){
            const {lengthh, row, data} = action.payload;
            state.length = lengthh;
            state.nextPage = row;
            state.items = [...state.items,...data];
        },
        empty(state){
            state.length = 0;
            state.nextPage = 0;
            state.items = [];
            state.hasMore = true;
        },
        setLoading(state,action){
            state.hasMore = action.payload;
        },
        setDay(state,action){
            state.dayid = action.payload;
        },
        
        setSearch(state, action){
            state.search = action.payload;
        }
    }
});

export const classesActions = classesSlice.actions;

export default classesSlice;